import { Controller } from '@hotwired/stimulus';
export default class extends Controller {

    connect() {
        let timeout;
        let input = this.element.querySelector('.qty');
        this.element.addEventListener('click', (e) => {
            const matchesDecrease = e.target.matches('.quantity-dec, .quantity-dec *');
            const matchesIncrease = e.target.matches('.quantity-inc, .quantity-inc *');
            if (matchesDecrease || matchesIncrease) {
                e.stopPropagation();
                e.preventDefault();
            }
        });
        this.element.addEventListener('mousedown', (e) => {
            const matchesDecrease = e.target.matches('.quantity-dec, .quantity-dec *');
            const matchesIncrease = e.target.matches('.quantity-inc, .quantity-inc *');
            if (matchesDecrease || matchesIncrease) {
                e.stopPropagation();
                e.preventDefault();

                let val = input.value ? parseInt(input.value) : 1;
                if (matchesDecrease) {
                    input.value = val > 1 ? val - 1 : val;
                } else if (matchesIncrease) {
                    if (input.hasAttribute('max') && input.getAttribute('max') ) {
                        input.value = val < input.getAttribute('max') ? val + 1 : val;
                    } else {
                        input.value = val + 1;
                    }
                }
                input.dispatchEvent(new Event('change', { 'bubbles': true }));
            }
        });
        input.addEventListener('change', () => {
            const update_cart_btn = document.querySelector('[name="update_cart"]');
            if (update_cart_btn) {
                if (timeout !== undefined) {
                    clearTimeout(timeout);
                }
                timeout = setTimeout(() => {
                    update_cart_btn.click();
                }, 800);
            }
        });
    }
}